export default __webpack_public_path__ + "assets/68e5333ed6c10dd8ef437877490d9137.png";